import React from 'react';
import { Card } from 'react-bootstrap';
import { ProductClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { ImageSetter } from '../MaterialEditor/ImageSetter';
import { MatProps } from './MatProps';


export function SingleProductMaterialEditor(props: {
    matProp: MatProps;
    updateMatProp: (interiorMaterialId: number, props: Partial<MatProps>) => void;
    productId: number;
    onChange: () => void;
}) {

    const {
        matProp,
        updateMatProp,
        productId
    } = { ...props };

    const client = useClient(ProductClient);

    async function setImage(interiorMaterialId: number, file: File, type: "picture" | "drawing") {
        try {
            const extension = file.type.split("/")[1];
            if (type === "drawing") {
                await client.setDrawingImage(productId
,
                    interiorMaterialId,
                    extension,
                    { data: file, fileName: file.name }
                );
            }
            else if (type === "picture") {
                await client.setPictureImage(productId
,
                    interiorMaterialId,
                    extension,
                    { data: file, fileName: file.name }
                );
            }
            else {
                throw new Error("Unknown image type");
            }
        }
        finally {
            props.onChange();
        }
    }
    

    return (
        <Card key={matProp.id}>
            <Card.Header>
                Interior material: {matProp.name}
            </Card.Header>
            <Card.Body>
                <div className="form-group form-check">
                    <input type="checkbox"
                        className="form-check-input"
                        id={`active-${matProp.id}`}
                        checked={matProp.isActive}
                        onChange={evt => updateMatProp(
                            matProp.id,
                            { isActive: evt.target.checked })
                        }
                    />
                    <label className="form-check-label"
                        htmlFor={`active-${matProp.id}`}>
                        Active
                    </label>
                </div>
                <div className="form-group">
                    <label htmlFor={`external-id-${matProp.id}`}>
                        Product Number
                    </label>
                    <input className="form-control"
                        id={`external-id-${matProp.id}`}
                        value={matProp.externalId}
                        onChange={evt => updateMatProp(
                            matProp.id,
                            { externalId: evt.target.value })
                        }
                    />

                </div>

                Drawing Image:
                <ImageSetter url={matProp.drawingImageUrl}
                    onSet={file => setImage(matProp.id, file, "drawing")}
                />

                Picture Image:
                <ImageSetter url={matProp.pictureImageUrl}
                    onSet={file => setImage(matProp.id, file, "picture")}
                />

            </Card.Body>
        </Card>
    );
}
